import { captureGTMEventAddToCart } from '@/lib/gtm';
import { getCartDetailById } from '@/services/hostCart.service';
import { getPageURL, ROUTE_CONFIG } from '@/services/hostPortal.service';
import * as HttpService from '@/services/http.service';
import {
  GET_PRODUCT,
  GET_PRODUCT_BREADCRUMBS,
  GET_PRODUCT_BY_ID,
  GET_PRODUCTS
} from '@/services/url.service';

export const getProducts = ({
  skip = 0,
  limit = 10,
  parentCategory = '',
  category = '',
  subCategory = '',
  sortOrder = ''
}) =>
  HttpService.getWithoutAuth(
    GET_PRODUCTS(skip, limit, parentCategory, category, subCategory, sortOrder)
  );

export const getProduct = (slug) =>
  HttpService.getWithoutAuth(GET_PRODUCT(slug));

export const getProductBreadCrumbs = (slug) =>
  HttpService.getWithoutAuth(GET_PRODUCT_BREADCRUMBS(slug));

export const getProductById = (productId) =>
  HttpService.getWithoutAuth(GET_PRODUCT_BY_ID(productId));

export const getBreadCrumbs = (productBreadCrumbs, product) => {
  let breadCrumbs = [
    {
      name: 'Home',
      link: getPageURL({
        pageName: ROUTE_CONFIG.HOME_PAGE.label
      })
    },
    {
      name: productBreadCrumbs.parentCategoryName,
      link: getPageURL({
        pageName: ROUTE_CONFIG.L0_CATEGORY.label,
        pathParams: {
          parentSlug: productBreadCrumbs.parentCategorySlug
        }
      })
    },
    {
      name: productBreadCrumbs.categoryName,
      link: getPageURL({
        pageName: ROUTE_CONFIG.L1_CATEGORY.label,
        pathParams: {
          categorySlug: productBreadCrumbs.categorySlug,
          parentSlug: productBreadCrumbs.parentCategorySlug
        }
      })
    },
    {
      name: productBreadCrumbs.subCategoryName,
      link: getPageURL({
        pageName: ROUTE_CONFIG.L2_CATEGORY.label,
        pathParams: {
          categorySlug: productBreadCrumbs.categorySlug,
          parentSlug: productBreadCrumbs.parentCategorySlug,
          subCategorySlug: productBreadCrumbs.subCategorySlug
        }
      })
    },
    {
      name: product.name,
      link: getPageURL({
        pageName: ROUTE_CONFIG.PDP.label,
        pathParams: { slug: product.slug }
      })
    }
  ];
  if (productBreadCrumbs && !productBreadCrumbs.parentCategoryName) {
    breadCrumbs = [
      {
        name: 'Home',
        link: getPageURL({
          pageName: ROUTE_CONFIG.HOME_PAGE.label
        })
      },
      {
        name: productBreadCrumbs.categoryName,
        link: getPageURL({
          pageName: ROUTE_CONFIG.L0_CATEGORY.label,
          pathParams: {
            parentSlug: productBreadCrumbs.categorySlug
          }
        })
      },
      {
        name: productBreadCrumbs.subCategoryName,
        link: getPageURL({
          pageName: ROUTE_CONFIG.L1_CATEGORY.label,
          pathParams: {
            categorySlug: productBreadCrumbs.subCategorySlug,
            parentSlug: productBreadCrumbs.categorySlug
          }
        })
      },
      {
        name: product.name,
        link: getPageURL({
          pageName: ROUTE_CONFIG.PDP.label,
          pathParams: { slug: product.slug }
        })
      }
    ];
  }
  return breadCrumbs;
};

export const handleAddToCart = async ({
  createCart,
  isQuantityInvalid,
  pageName,
  product,
  quantity,
  revertQuantityToMin,
  setShowAddedToCartAlert,
  updateCartInPortalHeader
}) => {
  const {
    availableDiscount,
    categories,
    id,
    name,
    price: { price, minPrice },
    productMedia,
    type
  } = product;

  if (!isQuantityInvalid) {
    captureGTMEventAddToCart({
      availableDiscount,
      categories,
      id,
      minPrice,
      name,
      pageName,
      price,
      productMedia,
      quantity,
      type
    });

    const isCartCreated = await createCart({
      product,
      quantity,
      revertQuantityToMin
    });

    if (isCartCreated) {
      const { entity } = await getCartDetailById({
        cartId: isCartCreated.cartId
      });

      updateCartInPortalHeader && updateCartInPortalHeader(entity);
      setShowAddedToCartAlert(true);
      setTimeout(() => {
        setShowAddedToCartAlert(false);
      }, 5000);
    }
  }
};

export const increaseQuantity = ({
  maxBookable,
  quantity,
  setQuantity,
  setShowQuantityRangeAlert
}) => {
  if (quantity >= maxBookable) {
    setShowQuantityRangeAlert(true);
  }
  setQuantity((prevQuantity) => prevQuantity + 1);
};

export const decreaseQuantity = ({
  quantity,
  minBookable,
  maxBookable,
  setQuantity,
  setShowQuantityRangeAlert
}) => {
  setShowQuantityRangeAlert(
    Boolean(quantity <= minBookable || quantity - 1 > maxBookable)
  );
  setQuantity((prevQuantity) => prevQuantity - 1);
};
